import { useModerationSettings } from '@tribeplatform/react-sdk/hooks'

import { AgedBasedModeration } from './AgedBasedModeration.js'
import { AISpamDetector } from './AISpamDetector.js'
import { FlaggedMembers } from './FlaggedMembers.js'
import { ModeratedContents } from './ModeratedContents.js'
import { ModerationAlerts } from './ModerationAlerts.js'

export const ModerationSettings = () => {
  const { data: moderationSettings } = useModerationSettings({
    fields: 'all',
  })

  if (!moderationSettings) {
    return null
  }

  return (
    <div className="max-w-3xl flex flex-col space-y-5">
      <AISpamDetector moderationSettings={moderationSettings} />
      <ModerationAlerts moderationSettings={moderationSettings} />
      <ModeratedContents moderationSettings={moderationSettings} />
      <AgedBasedModeration moderationSettings={moderationSettings} />
      <FlaggedMembers />
    </div>
  )
}
